import { useTranslation } from "next-i18next";

export const getRandomReviewContent = (platform) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation("checkout");

  const reviews: Array<any> = t(`reviews.${platform}`, {
    returnObjects: true,
    defaultValue: []
  });
  const reviewLength = reviews.length;
  const randomNumber1 = Math.floor(Math.random() * (reviewLength - 2) + 1);
  const randomNumber2 = Math.floor(Math.random() * randomNumber1);
  const randomNumber3 = Math.floor(
    Math.random() * (reviewLength - randomNumber1 - 1) + randomNumber1 + 1
  );
  return [reviews[randomNumber1], reviews[randomNumber2], reviews[randomNumber3]];
};
